import styles from '../data/mapStyles';
import { isMobile } from './checkDevice';

const API_ID = 'AIzaSyAsZMENvgli001R3mNSM-9xVM8jrxt1fBg'
const DEFAULT_ZOOM = 15.5;
const CENTER = { lat: 51.512617, lng: -0.076318 };
const ICON_SCALE = isMobile() ? 9 : 16;

let logoLat = document.querySelector('[data-building-lat]');
let logoLng = document.querySelector('[data-building-lng]');

let LOGO_POSITION;

if (logoLat && logoLng) {
  logoLat = Number(logoLat.dataset.buildingLat);
  logoLng = Number(logoLng.dataset.buildingLng);
  LOGO_POSITION = { lat: logoLat, lng: logoLng };
}

export default () => {
  const script = document.createElement('script');
  script.src = API_ID 
    ? `https://maps.googleapis.com/maps/api/js?key=${API_ID}&callback=initMap`
    : `https://maps.googleapis.com/maps/api/js?sensor=false&callback=initMap`;
  script.async = true;
  document.body.appendChild(script);

  let map;
  let markers = [];
  let infoWindows = [];

  const setMapOnAll = (map) => {
    for (let i = 0; i < markers.length; i++) {
      markers[i].setMap(map);
    }
  }

  const hideMarkers = () => {
    setMapOnAll(null);
  }

  const deleteMarkers = () => {
    hideMarkers();
    markers = [];
    infoWindows = [];
  }

  const addMarker = (position, title, index, content) => {
    const icon = {
      path: google.maps.SymbolPath.CIRCLE,
      scale: ICON_SCALE,
      fillColor: "#FFFFFF",
      fillOpacity: 1,
      strokeWeight: 0
    }
    const button = content.buttonlink && content.buttonlabel 
      ? `<a class="btn btn--beige map-btn__link" href="${content.buttonlink}" target="_blank">${content.buttonlabel}</a>`
      : '';

    const contentString = `
      <div class="map-btn">
        <div class="map-btn__inner">
          <h3 class="map-btn__title">${content.title}</h3>
          <p class="map-btn__descr">${content.description}</p>
        </div>

        ${button}
      </div>
    `
    
    const infowindow = new google.maps.InfoWindow({
      content: contentString,
      maxWidth: 257,
      pixelOffset: new google.maps.Size(128, 280),
    });

    infoWindows.push(infowindow)

    const marker = new google.maps.Marker({
      position,
      map,
      title,
      icon
    });

    const logo = isMobile() 
    ? "wp-content/themes/muro/assets/img/icons/map-logo-mobile.svg"
    : "wp-content/themes/muro/assets/img/icons/map-logo-desctop.svg"

    if (LOGO_POSITION) {
      new google.maps.Marker({
        position: LOGO_POSITION,
        map,
        icon: logo,
        clickable: false,
      });  
    }

   
    marker.index = index;

    // marker.setAnimation(google.maps.Animation.DROP);

    marker.addListener("click", () => {
      const icon = {
        path: google.maps.SymbolPath.CIRCLE,
        scale: ICON_SCALE,
        fillColor: "#000",
        fillOpacity: 1,
        strokeWeight: 0
      }

      const iconWhite = {
        path: google.maps.SymbolPath.CIRCLE,
        scale: ICON_SCALE,
        fillColor: "#FFFFFF",
        fillOpacity: 1,
        strokeWeight: 0
      }
 
      infoWindows.forEach(infoWindow => {
        if (infoWindow.close) {
          infoWindow.close();
        }
      })

      markers.forEach(marker => {
        marker.setIcon(iconWhite)
      })

      markers[index].setIcon(icon)

      infoWindows[index].open({
        anchor: marker,
        map,
        shouldFocus: true,
      });

      google.maps.event.addListener(map, "click", function(event) {
        infowindow.close();

        const iconWhite = {
          path: google.maps.SymbolPath.CIRCLE,
          scale: ICON_SCALE,
          fillColor: "#FFFFFF",
          fillOpacity: 1,
          strokeWeight: 0
        }

        markers.forEach(marker => {
          marker.setIcon(iconWhite)
        })
      });
    });

    markers.push(marker);

    return marker;
  }

  const addPointsList = (itemList, isBounds = true) => {
    const bounds = new google.maps.LatLngBounds();
    deleteMarkers();

    const points = [...itemList.querySelectorAll('[point]')];

    points.forEach((point, i) => {
      const content = {
        title: point.dataset.title,
        description: point.dataset.description,
        buttonlabel: point.dataset.buttonlabel,
        buttonlink: point.dataset.buttonlink,
      }
      const marker = addMarker(
        {
          lat: Number(point.dataset.maplat), lng: Number(point.dataset.maplng)
        }, 
        point.dataset.title,
        i,
        content
      )

      bounds.extend(marker.position);

      point.addEventListener('click', () => {
        infoWindows.forEach(infoWindow => {
          if (infoWindow.close) {
            infoWindow.close();
          }
        });
  
        infoWindows[i].open({
          anchor: markers[i],
          map,
          shouldFocus: true,
        });

        const icon = {
          path: google.maps.SymbolPath.CIRCLE,
          scale: ICON_SCALE,
          fillColor: "#000",
          fillOpacity: 1,
          strokeWeight: 0
        };
  
        const iconWhite = {
          path: google.maps.SymbolPath.CIRCLE,
          scale: ICON_SCALE,
          fillColor: "#FFFFFF",
          fillOpacity: 1,
          strokeWeight: 0
        };

        markers.forEach(marker => {
          marker.setIcon(iconWhite)
        });

        markers[i].setIcon(icon);
      })
    })

    if(isBounds) {
      map.fitBounds(bounds);
    }
  }

  const accordions = () => {
    const lists = [...document.querySelectorAll('.locations__item')];

    const closeAllTabs = () => {
      lists.forEach(list => {
        const itemList = list.querySelector('.locations__item-list');
        itemList.classList.remove('locations__item-list--open');
      })
    }

    const firstActive = lists[0].querySelector('.locations__item-list--open')
    addPointsList(firstActive, false);

    lists.forEach((list, index) => {
      const button = list.querySelector('[accordion-button]');
      button.addEventListener('click', () => {
        const itemList = list.querySelector('.locations__item-list');

        if (itemList.classList.contains('locations__item-list--open')) {
          itemList.classList.remove('locations__item-list--open');
          return;
        }

        closeAllTabs();

        itemList.classList.add('locations__item-list--open');

        addPointsList(itemList);
      })
    })
  }

  const initMapLogic = () => {
    const container = document.getElementById('google-map');
    map = new google.maps.Map(container, {
      center: CENTER,
      zoom: DEFAULT_ZOOM,
      styles,
      mapTypeControl: false,
      streetViewControl: false,
      fullscreenControl: false,
      zoomControl: true,
      zoomControlOptions: {
        position: google.maps.ControlPosition.RIGHT_TOP,
      },
      clickableIcons: false
    });
  }

  window.initMap = () => {
    initMapLogic();
    accordions();
  };
}
